import React from 'react';

import * as CONSTANTS from "../constants";

import AccountNavigation from './account-navigation';
import LogoutButton from '../components/logout-button';
import IFrame from '../components/iframe';

const paymentCardsURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/secure/myaccount.aspx?screen=paymentCards&resize=true`;
const membershipsURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/secure/myaccount.aspx?screen=memberships&resize=true`;

const AccountPayments = () => {

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--payments'>
                <div className='booking-pathway__main-content'>
                    <IFrame url={paymentCardsURL} id="SpektrixAccountIFrame" title="Payment methods" hasLoader="true" />

                    <div className='memberships-iframe'>
                        <IFrame url={membershipsURL} ignoreNavigate id="SpektrixMembershipsIFrame" title="Membership auto-renewal" />
                    </div>
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />
                </div>
            </div>
        </>
    );
};

export default AccountPayments;
